// src/components/ProductPage.jsx
import { useParams } from "react-router-dom";
import React, { useEffect, useState, useMemo } from "react";
import { doc, getDoc } from "firebase/firestore";
import db from "./firebase/firebase";
import { Link, useNavigate } from 'react-router-dom';

export default function Product({ product }) {

  const history = useNavigate()

  const [mainImageIndex, setMainImageIndex] = useState(0);

  const [qty, setQty] = useState(1);
  const [message, setMessage] = useState(null);


  const S = {
    page: {
      width: "min(1100px, 94%)",
      margin: "28px auto",
      fontFamily:
        "Inter, ui-sans-serif, system-ui, -apple-system, Roboto, Arial",
      color: "#0f172a",
    },
    panel: {
      display: "grid",
      gridTemplateColumns: "1fr 420px",
      gap: 24,
      alignItems: "start",
    },
    gallery: {
      borderRadius: 12,
      overflow: "hidden",
      border: "1px solid rgba(0,0,0,0.06)",
      background: "white",
    },
    mainImgWrap: {
      width: "100%",
      minHeight: 320,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#f9fafb",
    },
    mainImg: {
      maxWidth: "100%",
      height: 380,
      margin: 10,
      objectFit: "contain",
      display: "block",
    },
    thumbs: { display: "flex", gap: 8, padding: 10, justifyContent: "center" },
    thumbBtn: (active) => ({
      width: 64,
      height: 48,
      borderRadius: 8,
      overflow: "hidden",
      border: active ? "2px solid #0ea5e9" : "1px solid #e6e6e9",
      background: "white",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "border 0.2s",
    }),
    details: {
      borderRadius: 12,
      padding: 22,
      border: "1px solid rgba(0,0,0,0.06)",
      background: "white",
      boxShadow: "0 6px 18px rgba(8,8,10,0.03)",
    },
    title: { fontSize: 20, fontWeight: 700, margin: 0, marginBottom: 10 },
    brand: { fontSize: 13, color: "#6b7280" },
    priceRow: {
      display: "flex",
      alignItems: "baseline",
      gap: 12,
      marginTop: 8,
      color: "#10b981"
    },
    price: { fontSize: 24, fontWeight: 800 },
    mrp: {
      fontSize: 14,
      color: "#6b7280",
      textDecoration: "line-through",
    },
    stockOk: { color: "#10b981", fontWeight: 600 },
    stockLow: { color: "#f59e0b", fontWeight: 600 },
    stockOut: { color: "#ef4444", fontWeight: 600 },
    select: {
      width: "100%",
      padding: "12px 14px",
      borderRadius: 10,
      border: "1px solid #e6e6e9",
      background: "white",
      marginTop: 12,
      fontSize: 15,
    },
    qtyInput: {
      display: "flex",
      alignItems: "center",
      borderRadius: 10,
      border: "1px solid #e6e6e9",
      padding: "6px 10px",
      background: "#f9fafb",
    },
    stepBtn: {
      border: "none",
      background: "transparent",
      padding: "6px 10px",
      cursor: "pointer",
      fontSize: 18,
      color: "#0f172a",
    },
    btnPrimary: {
      padding: "12px 18px",
      borderRadius: 10,
      background: "linear-gradient(90deg, #0ea5e9, #0284c7)",
      color: "white",
      border: "none",
      fontWeight: 700,
      cursor: "pointer",
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      transition: "opacity 0.2s",
    },
    btnGreen: {
      padding: "12px 18px",
      borderRadius: 10,
      background: "linear-gradient(90deg, #16a34a, #15803d)",
      color: "white",
      border: "none",
      fontWeight: 700,
      cursor: "pointer",
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      transition: "opacity 0.2s",
    },
    btnSecondary: {
      padding: "12px 18px",
      borderRadius: 10,
      background: "white",
      color: "#0f172a",
      border: "1px solid #e6e6e9",
      cursor: "pointer",
      fontWeight: 600,
      transition: "background 0.2s",
    },
    row: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      marginTop: 16,
      flexWrap: "wrap",
    },
    section: {
      marginTop: 20,
      paddingTop: 10,
      borderTop: "1px solid #f0f0f2",
    },
    small: { fontSize: 14, color: "#6b7280", lineHeight: 1.6 },
    message: { marginTop: 12, color: "#075985" },
    stickyMobileBar: {
      position: "fixed",
      left: 0,
      right: 0,
      bottom: 0,
      display: "none",
      padding: 12,
      gap: 10,
      alignItems: "center",
      justifyContent: "space-between",
      background: "rgba(255,255,255,0.98)",
      borderTop: "1px solid #e6e6e9",
      boxShadow: "0 -2px 10px rgba(0,0,0,0.05)",
    },
  };

  const totalPrice = useMemo(() => {
    const unit = product.price ?? 0;
    return (unit * qty).toFixed(2);
  }, [qty]);

  const stock = 1000;
  const stockLabel =
    stock <= 0 ? "Out of stock" : stock < 5 ? `Only ${stock} left` : "In stock";

  return (
    <div style={S.page}>
      <div style={S.panel} className="product-panel">
        {/* Left: Gallery */}
        <div>
          <div style={S.gallery}>
            <div style={S.mainImgWrap}>
              <img
                src={product.images?.[mainImageIndex]}
                alt={`${product.title}`}
                style={S.mainImg}
              />
            </div>
            <div style={S.thumbs}>
              {product.images.map((src, i) => (
                <button
                  key={i}
                  style={S.thumbBtn(i === mainImageIndex)}
                  onClick={() => setMainImageIndex(i)}
                >
                  <img
                    src={src}
                    alt={`thumb ${i + 1}`}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </button>
              ))}
            </div>
          </div>

          <div style={{ marginTop: 12 }}>
            <div style={{ ...S.small, marginTop: 6 }}>
              <strong>Manufacturer:</strong> {product.manufacturer}
            </div>

            {product.expiry_date !== '' &&
              <div style={{ ...S.small, marginTop: 6 }}>
                <strong>Expiry:</strong> {product.expiry_date}
              </div>
            }

          </div>
        </div>

        {/* Right: Details */}
        <aside style={S.details} className="product-details">

          <div>
            <div style={S.brand}>{product.brand}</div>
            <h1 style={S.title}>{product.title}</h1>
            {/* <div style={{ fontSize: 14, color: "#6b7280" }}>
              ★ {product.rating?.avg ?? 4.5} ({product.rating?.count ?? 10})
            </div> */}
          </div>

          <div style={S.priceRow}>
            <div style={S.price}>${product.price}</div>
            {/* <div style={S.mrp}>${selectedVariant?.mrp}</div> */}
            <div
              style={{
                marginLeft: "auto",
                ...(stock <= 0
                  ? S.stockOut
                  : stock < 5
                    ? S.stockLow
                    : S.stockOk),
              }}
            >
              {stockLabel}
            </div>
          </div>

          <div style={S.row} className="product-buttons">
            <button style={S.btnSecondary}>Available for Pickup at Store</button>
            <button style={S.btnGreen} onClick={() => {
              history('/contact-us')
            }}>Contact Us</button>
          </div>

          <div style={S.section}>
            <div style={{ fontWeight: 700 }}>Directions</div>
            <div style={S.small}>{product.directions}</div>
          </div>

          <div style={S.section}>
            <div style={{ fontWeight: 700 }}>Description</div>
            <div style={S.small} dangerouslySetInnerHTML={{ __html: product.description }}></div>
          </div>

          {message &&
            <div
              style={S.message}
              dangerouslySetInnerHTML={{ __html: message }}
            >
            </div>}
        </aside>
      </div>

      {/* Responsive tweaks */}
      <style>{`
  @media (max-width: 820px) {
    .product-panel {
      display: flex !important;
      flex-direction: column !important;
      gap: 20px !important;
    }

    .product-details {
      margin-top: 16px !important;
    }

    .product-gallery img {
      max-height: 300px !important;
    }

    .product-buttons {
      flex-wrap: wrap !important;
    }
  }
`}</style>

    </div>
  );
}
